@if (isVisible()) {
<div [class]="appliedClasses()" class="absolute bg-white rounded shadow z-30">
  <ng-content></ng-content>
</div>
}
